module.exports = __webpack_public_path__ + "static/media/shop.c73b50d4.png";